import * as React from "react";
import "./index.css";
import Button from "../../Button";
import { BoostIcon, DeleteIcon, EditIcon } from "../../icons";
import AdTileImage from "../../../images/ad-tile-image.png";
import storageService from "../../../app/services/storageService";
import { useNavigate } from "react-router-dom";

const LiveAdTile = ({
  redirectUrl,
  classified,
  onDelete,
  onClick,
}) => {


  const navigate = useNavigate();
  return (
    <div className="live-ad-tile-base" onClick={(e) => {
      if (Array.from(e.target.classList).includes("no-navigate")) return;
      navigate(classified.status === "approved" ? `/listing/${classified.id}` : redirectUrl)
    }}>
      <img
        src={classified.properties && classified.properties.images?.length > 0 ? `${storageService.publicUrl(classified.properties.images[0])}` : AdTileImage}
        onError={(e) => {
          e.target.src = "https://i.imgur.com/6p9udbl.png"
          e.target.style.objectFit = "cover"
        }}
        alt="Nothing here"
        className={"live-ad-tile-image"}
      />
      <span>{classified.title}</span>
      <span dangerouslySetInnerHTML={{ __html: classified.description }} />
      <div className="live-ad-tile-footer">
        <button className={"ad-btn no-navigate"} onClick={onDelete}>
          <DeleteIcon className={"no-navigate"} size={25} fill={"rgba(0,0, 0, 0)"} />
        </button>
        <button className={"ad-btn no-navigate"} onClick={() => {
          navigate(redirectUrl ?? `/edit/${classified.id}`)
        }}>
          <EditIcon size={20} className={"no-navigate"} />
        </button>
        {classified.status === "approved" && (
          <button className={"ad-boost-btn no-navigate uppercase"} onClick={() => {
            navigate(`/submit?edit=${classified.id}`)
          }}>
            <BoostIcon size={25} className={"no-navigate"} />
            <div className="no-navigate">Post again</div>
          </button>
        )}
      </div>
    </div>
  );
};

export default LiveAdTile;
